import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { useNotifications } from "../hooks";
import { NotificationsList } from "./notifications-list";

export const NotificationsBell: React.FC = () => {
  const navigate = useNavigate();
  const [isOpened, setIsOpened] = useState(false);
  const { data } = useNotifications({ where: { isRead: false } });

  const unreadCount = data?.notifications?.total ?? 0;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpened(!isOpened)}
        className="relative p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-zinc-800 transition-colors"
        title="Notifications"
      >
        <Bell size={20} className="text-gray-600 dark:text-zinc-300" />
        {unreadCount > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-red-600 text-white text-[10px] font-semibold">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>

      {isOpened && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setIsOpened(false)} />
          <div className="absolute right-0 mt-2 w-80 max-w-[90vw] bg-white dark:bg-surface-dark-alt rounded-lg shadow-lg border border-gray-200 dark:border-zinc-800 z-40">
            <div className="px-3 py-2 border-b border-gray-100 dark:border-zinc-800">
              <p className="text-sm font-semibold text-gray-900 dark:text-zinc-100">
                Notifications
              </p>
            </div>

            <div className="max-h-96 overflow-y-auto">
              <NotificationsList
                onlyUnread
                max={8}
                onNavigate={() => setIsOpened(false)}
              />
            </div>

            <div className="px-3 py-2 border-t border-gray-100 dark:border-zinc-800">
              <button
                type="button"
                onClick={() => {
                  setIsOpened(false);
                  navigate("/notifications");
                }}
                className="w-full text-center text-sm text-primary-600 dark:text-zinc-200 hover:underline"
              >
                Voir toutes les notifications
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
